var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.params.fund_code},[_c('FundInfo'),_c('div',{staticClass:"az-content-body"},[_c('div',{staticClass:"az-content az-content-dashboard-fifteen"},[_c('keep-alive',[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }